import {
    ComparatorPicker,
    ComparatorPickerBuilder,
    ComparatorPickerType,
    ComparisonOperator,
    Field,
    FieldType,
} from "../../vforms-model";
import { TextBox } from "../text-box/text-box";
import { Cid10EditorComponent } from "./cid10-editor.component";
import { Cid10Component } from "./cid10.component";
import { ComparisonExpression } from "../../expression-settings/model";

export class Cid10Type extends FieldType {
    static Id = "cid10";

    constructor() {
        super();
        this.id = Cid10Type.Id;
        this.icon = "mat_outline:search";
        this.previewComponent = Cid10Component;
        this.editorComponent = Cid10EditorComponent;
    }

    createField(): Field {
        return new Cid10Field(this);
    }

    supportedComparisonOperators(): ComparisonOperator[] {
        return [...super.supportedComparisonOperators(), ComparisonOperator.Contains];
    }

    evaluate(expression: ComparisonExpression, value: any): boolean {
        let selection = [];
        if (value && typeof value === "string") {
            selection = JSON.parse(value);
        } else if (value) {
            selection = [...value];
        }

        switch (expression.operator) {
            case ComparisonOperator.Contains:
                return selection.findIndex((i) => i.startsWith(`${expression.value}:`)) >= 0;
        }

        return super.evaluate(expression, value);
    }
}

export class Cid10Field extends TextBox {
    constructor(type: FieldType) {
        super(type);
    }
}

export class Cid10PickerBuilder extends ComparatorPickerBuilder {
    build(comparisonExpression: ComparisonExpression): ComparatorPicker {
        if (
            comparisonExpression.operator === ComparisonOperator.NotEmpty ||
            comparisonExpression.operator === ComparisonOperator.Empty
        ) {
            return new ComparatorPicker(ComparatorPickerType.None);
        }

        return new ComparatorPicker(ComparatorPickerType.Cid10Selection);
    }
}
